import * as React from "react";

const ForgotPasswordGraphic = ({ width = 640, height = 589, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 640 589"
    fill="none"
    {...props}
  >
    <path
      fill="#fff"
      d="M134.885 293.042c-4.797-9.25-6.809-15.878-6.809-17.411 0-3.033 6.595-4.847 6.595-4.847 10.288-5.441 58.678 2.424 80.457 6.051a248.723 248.723 0 0 0 36.898 3.627s3.017-2.407 6.595-5.441c3.578-3.033 20.559-22.983 27.22-24.731 6.661-1.747 12.695 2.424 12.695 2.424s10.898 6.595 9.068 7.864c-1.83 1.27-28.424 24.187-35.084 28.424-6.661 4.237-20.56 2.424-32.661 4.847-10.42 2.078-52.627 4.65-62.305 5.441a35.167 35.167 0 0 1-21.779-1.813"
    />
    <mask
      id="a"
      width={180}
      height={52}
      x={128}
      y={249}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "luminance",
      }}
    >
      <path
        fill="#fff"
        d="M134.885 293.042c-4.797-9.25-6.809-15.878-6.809-17.411 0-3.033 6.595-4.847 6.595-4.847 10.288-5.441 58.678 2.424 80.457 6.051a248.723 248.723 0 0 0 36.898 3.627s3.017-2.407 6.595-5.441c3.578-3.033 20.559-22.983 27.22-24.731 6.661-1.747 12.695 2.424 12.695 2.424s10.898 6.595 9.068 7.864c-1.83 1.27-28.424 24.187-35.084 28.424-6.661 4.237-20.56 2.424-32.661 4.847-10.42 2.078-52.627 4.65-62.305 5.441a35.167 35.167 0 0 1-21.779-1.813"
      />
    </mask>
    <g mask="url(#a)">
      <path
        fill="#EA580C"
        d="M298.652 252.648s-6.051-4.237-12.695-2.423c-6.645 1.813-23.593 21.779-27.221 24.73-3.627 2.951-6.594 5.441-6.594 5.441a248.723 248.723 0 0 1-36.899-3.627c-21.779-3.627-70.169-11.541-80.457-6.051 0 0-6.594 1.814-6.594 4.847a20.798 20.798 0 0 0 1.302 4.946l.907.33s12.085-1.269 38.168-.643c26.082.627 86.408 4.204 90.283 5.606 1.649.626 13.338-2.012 26.297-6.595 9.892-8.062 21.515-18.136 22.686-18.845 1.715-1.072-9.183-7.716-9.183-7.716Z"
      />
      <path
        fill="#fff"
        d="M298.652 252.648s-6.051-4.237-12.695-2.423c-6.645 1.813-23.593 21.779-27.221 24.73-3.627 2.951-6.594 5.441-6.594 5.441a248.723 248.723 0 0 1-36.899-3.627c-21.779-3.627-70.169-11.541-80.457-6.051 0 0-6.594 1.814-6.594 4.847a20.798 20.798 0 0 0 1.302 4.946l.907.33s12.085-1.269 38.168-.643c26.082.627 86.408 4.204 90.283 5.606 1.649.626 13.338-2.012 26.297-6.595 9.892-8.062 21.515-18.136 22.686-18.845 1.715-1.072-9.183-7.716-9.183-7.716Z"
        opacity={0.5}
      />
    </g>
    <path
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M134.885 293.042c-4.797-9.25-6.809-15.878-6.809-17.411 0-3.033 6.595-4.847 6.595-4.847 10.288-5.441 58.678 2.424 80.457 6.051a248.723 248.723 0 0 0 36.898 3.627s3.017-2.407 6.595-5.441c3.578-3.033 20.559-22.983 27.22-24.731 6.661-1.747 12.695 2.424 12.695 2.424s10.898 6.595 9.068 7.864c-1.83 1.27-28.424 24.187-35.084 28.424-6.661 4.237-20.56 2.424-32.661 4.847-10.42 2.078-52.627 4.65-62.305 5.441a35.167 35.167 0 0 1-21.779-1.813"
    />
    <path
      fill="#fff"
      d="M373.8 346.822a12.875 12.875 0 0 1 11.409-6.875h109.969s7.947 0 5.572 15.103c-2.374 15.102-34.985 107.314-42.866 135.194-7.881 27.879-9.546 86.639-9.546 86.639H316.441s10.453-140.519 57.359-230.061Z"
    />
    <mask
      id="b"
      width={186}
      height={238}
      x={316}
      y={339}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "luminance",
      }}
    >
      <path
        fill="#fff"
        d="M373.8 346.822a12.875 12.875 0 0 1 11.409-6.875h109.969s7.947 0 5.572 15.103c-2.374 15.102-34.985 107.314-42.866 135.194-7.881 27.879-9.546 86.639-9.546 86.639H316.441s10.453-140.519 57.359-230.061Z"
      />
    </mask>
    <g mask="url(#b)">
      <path
        fill="#000"
        d="M423.327 339.947h-38.118a12.876 12.876 0 0 0-11.409 6.875c-46.906 89.542-57.474 230.012-57.474 230.012h59.156l14.591-55.413 60.837 12.546c.429-4.649.923-9.381 1.5-14.047l-1.335-14.838s-12.464-13.107-16.388-16.388c-3.924-3.281-1.319-9.2-1.979-34.771-.659-25.572-23.609-43.955-32.15-59.7-8.54-15.745 4.6-25.588 16.405-41.333 4.204-5.688 5.919-9.876 6.364-12.943Z"
        opacity={0.16}
      />
    </g>
    <path
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M373.8 346.822a12.875 12.875 0 0 1 11.409-6.875h109.969s7.947 0 5.572 15.103c-2.374 15.102-34.985 107.314-42.866 135.194-7.881 27.879-9.546 86.639-9.546 86.639H316.441s10.453-140.519 57.359-230.061Z"
    />
    <path
      fill="#263238"
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M476.102 366.178c-11.112 25.935-34.623 128.6-38.448 210.656h10.618s1.649-58.826 9.546-86.64C465.715 462.38 498.36 370.152 500.685 355c2.324-15.152-5.573-15.102-5.573-15.102s-10.09 5.49-19.01 26.28ZM282.923 314.343s-17.542-10.288-24.187-28.424c-6.644-18.136 52.017-47.186 77.49-48.999 25.472-1.814 32.661 4.83 47.812 30.847 15.152 26.017 25.407 61.695 17.543 79.237-7.865 17.542-21.17 21.779-11.541 36.271 9.628 14.493 36.898 55.644 35.084 75-1.813 19.356-20.559 36.272-47.812 38.118-27.254 1.847-63.525-14.525-93.762-41.217-30.238-26.693-22.39-65.949-11.541-78.644 10.848-12.695 27.22-17.542 28.423-30.237 1.204-12.695-17.509-31.952-17.509-31.952Z"
    />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M357.692 285.639c9.315 17.344 20.972 40.575 24.615 54.605 6.364 24.566-26.379 40.031-17.295 51.852M344.997 262.92s3.627 6.182 8.639 15.283M393.865 306.561a44.686 44.686 0 0 1 2.077 10.024M351.295 253.901s28.655 21.17 40.097 46.51M311.528 269.778c-20.46 5.738-49.89 15.053-47.499 20.428M330.439 264.733s-4.369 1.088-10.882 2.836M305.131 254.05a105.52 105.52 0 0 1 36.272-4.782M296.789 257.462a45.924 45.924 0 0 1 5.737-2.506"
    />
    <path
      fill="#fff"
      d="M134.885 293.042a79.347 79.347 0 0 1-6.594-16.026 78.32 78.32 0 0 0 6.594 16.026Zm-6.776-16.966v.363a.879.879 0 0 0 0-.363Zm6.776 16.949a151.053 151.053 0 0 0 22.819 32.183c21.779 23.593 84.694 85.304 90.679 89.541 5.984 4.237 4.237 16.322 0 28.424-4.238 12.101-19.966 29.677-19.356 49 .61 19.322 6.595 48.999 6.051 55.05-.545 6.051-15.68 26.627-15.68 26.627h156.067s-19.455-24.731-19.455-33.189c0-8.458 26.709-116.827 27.913-124.692 1.204-7.864-3.627-13.305-13.305-13.915-9.678-.61-46.576-8.474-48.39-14.525-1.813-6.051 9.678-29.034 9.678-29.034l-36.271 1.814s-1.814 15.729-4.238 18.762c-2.423 3.034-6.05-3.033-14.525-7.254-8.474-4.221-24.73-7.864-30.847-12.712-6.117-4.847-64.118-59.353-64.118-59.353"
    />
    <mask
      id="c"
      width={257}
      height={298}
      x={128}
      y={276}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "luminance",
      }}
    >
      <path
        fill="#fff"
        d="M134.885 293.042a79.347 79.347 0 0 1-6.594-16.026 78.32 78.32 0 0 0 6.594 16.026Zm-6.776-16.966v.363a.879.879 0 0 0 0-.363Zm6.776 16.949a151.053 151.053 0 0 0 22.819 32.183c21.779 23.593 84.694 85.304 90.679 89.541 5.984 4.237 4.237 16.322 0 28.424-4.238 12.101-19.966 29.677-19.356 49 .61 19.322 6.595 48.999 6.051 55.05-.545 6.051-15.68 26.627-15.68 26.627h156.067s-19.455-24.731-19.455-33.189c0-8.458 26.709-116.827 27.913-124.692 1.204-7.864-3.627-13.305-13.305-13.915-9.678-.61-46.576-8.474-48.39-14.525-1.813-6.051 9.678-29.034 9.678-29.034l-36.271 1.814s-1.814 15.729-4.238 18.762c-2.423 3.034-6.05-3.033-14.525-7.254-8.474-4.221-24.73-7.864-30.847-12.712-6.117-4.847-64.118-59.353-64.118-59.353"
      />
    </mask>
    <g mask="url(#c)">
      <path
        fill="#EA580C"
        d="M255.291 363.771a295.015 295.015 0 0 0 6.034 10.041s10.173 5.721 12.712 5.721c2.539 0 17.806 8.243 17.806 8.243s12.728-3.182 8.243-13.997a34.153 34.153 0 0 0-5.309-7.617c-.758 4.798-1.978 11.079-3.413 12.876-2.423 3.017-6.05-3.033-14.525-7.254-5.49-2.737-14.376-5.243-21.548-8.013ZM224.229 339.288c-18.68-17.295-42.322-39.47-42.322-39.47l-13.751-1.979-1.648.924s38.81 34.342 47.07 38.167a25.806 25.806 0 0 0 10.651 2.358ZM243.799 357.193l-1.484-1.319c.759 1.253 1.187 2.044 1.187 2.044l.297-.725Z"
      />
      <g fill="#fff" opacity={0.5}>
        <path d="M255.291 363.771a295.015 295.015 0 0 0 6.034 10.041s10.173 5.721 12.712 5.721c2.539 0 17.806 8.243 17.806 8.243s12.728-3.182 8.243-13.997a34.153 34.153 0 0 0-5.309-7.617c-.758 4.798-1.978 11.079-3.413 12.876-2.423 3.017-6.05-3.033-14.525-7.254-5.49-2.737-14.376-5.243-21.548-8.013ZM224.229 339.288c-18.68-17.295-42.322-39.47-42.322-39.47l-13.751-1.979-1.648.924s38.81 34.342 47.07 38.167a25.806 25.806 0 0 0 10.651 2.358ZM243.799 357.193l-1.484-1.319c.759 1.253 1.187 2.044 1.187 2.044l.297-.725Z" />
      </g>
    </g>
    <path
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M128.076 275.631a2.853 2.853 0 0 0 0 .346m.215 1.039a79.347 79.347 0 0 0 6.594 16.026 78.32 78.32 0 0 1-6.594-16.026Zm0 0a2.982 2.982 0 0 1-.099-.478m6.693 16.487a151.053 151.053 0 0 0 22.819 32.183c21.779 23.593 84.694 85.304 90.679 89.541 5.984 4.237 4.237 16.322 0 28.424-4.238 12.101-19.966 29.677-19.356 49 .61 19.322 6.595 48.999 6.051 55.05-.545 6.051-15.68 26.627-15.68 26.627h156.067s-19.455-24.731-19.455-33.189c0-8.458 26.709-116.827 27.913-124.692 1.204-7.864-3.627-13.305-13.305-13.915-9.678-.61-46.576-8.474-48.39-14.525-1.813-6.051 9.678-29.034 9.678-29.034l-36.271 1.814s-1.814 15.729-4.238 18.762c-2.423 3.034-6.05-3.033-14.525-7.254-8.474-4.221-24.73-7.864-30.847-12.712-6.117-4.847-64.118-59.353-64.118-59.353m-53.798-23.676v.363a.879.879 0 0 0 0-.363Z"
    />
    <path
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M181.907 299.818s-19.323.362-30.106-8.524"
    />
    <path
      fill="#fff"
      d="M322.245 387.529c-1.814-6.034 9.678-29.034 9.678-29.034l-36.272 1.814s-1.814 15.729-4.237 18.762c-2.424 3.034-6.051-3.033-14.525-7.254a34.779 34.779 0 0 0-2.078-.956l-2.192 34.474s3.182 33.387 41.333 27.039c15.448-2.572 31.935-16.355 46.164-31.853-14.641-2.687-36.486-8.359-37.871-12.992Z"
    />
    <mask
      id="d"
      width={89}
      height={76}
      x={272}
      y={358}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "luminance",
      }}
    >
      <path
        fill="#fff"
        d="M322.245 387.529c-1.814-6.034 9.678-29.034 9.678-29.034l-36.272 1.814s-1.814 15.729-4.237 18.762c-2.424 3.034-6.051-3.033-14.525-7.254a34.779 34.779 0 0 0-2.078-.956l-2.192 34.474s3.182 33.387 41.333 27.039c15.448-2.572 31.935-16.355 46.164-31.853-14.641-2.687-36.486-8.359-37.871-12.992Z"
      />
    </mask>
    <g mask="url(#d)">
      <path
        fill="#EA580C"
        d="M321.223 363.062s-2.193 12.3-3.957 25.901c-1.764 13.602-3.067 23.725-3.067 23.725l8.046-25.159 9.068-26.66s-8.772 0-10.09 2.193Z"
      />
      <path
        fill="#fff"
        d="M321.223 363.062s-2.193 12.3-3.957 25.901c-1.764 13.602-3.067 23.725-3.067 23.725l8.046-25.159 9.068-26.66s-8.772 0-10.09 2.193Z"
        opacity={0.5}
      />
    </g>
    <path
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M322.245 387.529c-1.814-6.034 9.678-29.034 9.678-29.034l-36.272 1.814s-1.814 15.729-4.237 18.762c-2.424 3.034-6.051-3.033-14.525-7.254a34.779 34.779 0 0 0-2.078-.956l-2.192 34.474s3.182 33.387 41.333 27.039c15.448-2.572 31.935-16.355 46.164-31.853-14.641-2.687-36.486-8.359-37.871-12.992Z"
    />
    <path
      fill="#EA580C"
      d="M291.397 379.071c-2.423 3.017-6.05-3.033-14.525-7.254-5.342-2.688-13.849-5.128-20.889-7.766-1.995-4.731-4.633-10.898-6.331-14.624-3.017-6.594-7.864-2.423-7.864-2.423a35.269 35.269 0 0 1-6.051-9.678c-3.017-6.595-7.864-6.051-14.509-7.254-6.644-1.204-20.575-13.916-20.575-13.916s-6.513-4.946-9.2-7.402c-3.133 6.166-10.634 17.014-26.858 23.791 25.868 27.022 78.347 78.363 83.854 82.221 6.05 4.22 4.237 16.322 0 28.423-4.238 12.102-19.966 29.677-19.356 49 .61 19.323 6.595 49 6.05 55.051-.544 5.391-12.612 22.29-15.234 25.917l6.15.693h32.018c-.181-16.224-.165-82.436 10.931-108.815 12.712-30.32 22.389-85.964 22.389-85.964Z"
    />
    <mask
      id="e"
      width={128}
      height={266}
      x={164}
      y={308}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "luminance",
      }}
    >
      <path
        fill="#fff"
        d="M291.397 379.071c-2.423 3.017-6.05-3.033-14.525-7.254-5.342-2.688-13.849-5.128-20.889-7.766-1.995-4.731-4.633-10.898-6.331-14.624-3.017-6.594-7.864-2.423-7.864-2.423a35.269 35.269 0 0 1-6.051-9.678c-3.017-6.595-7.864-6.051-14.509-7.254-6.644-1.204-20.575-13.916-20.575-13.916s-6.513-4.946-9.2-7.402c-3.133 6.166-10.634 17.014-26.858 23.791 25.868 27.022 78.347 78.363 83.854 82.221 6.05 4.22 4.237 16.322 0 28.423-4.238 12.102-19.966 29.677-19.356 49 .61 19.323 6.595 49 6.05 55.051-.544 5.391-12.612 22.29-15.234 25.917l6.15.693h32.018c-.181-16.224-.165-82.436 10.931-108.815 12.712-30.32 22.389-85.964 22.389-85.964Z"
      />
    </mask>
    <g mask="url(#e)">
      <path
        fill="#000"
        d="M276.872 371.817c-5.341-2.688-13.849-5.128-20.889-7.766-1.995-4.731-4.633-10.898-6.331-14.624-3.017-6.594-7.864-2.423-7.864-2.423a35.269 35.269 0 0 1-6.051-9.678c-3.017-6.595-7.864-6.051-14.509-7.254-6.644-1.204-20.575-13.916-20.575-13.916s-6.513-4.946-9.2-7.402a44.688 44.688 0 0 1-4.765 7.402c10.816 9.151 22.752 18.845 26.923 20.774 8.244 3.809 10.173.627 16.488 4.452 6.314 3.825 13.354 16.487 13.354 16.487s3.825-10.189 7.007-3.182c3.182 7.007 10.816 19.075 10.816 19.075s10.172 5.721 12.711 5.721c1.995 0 11.772 5.078 15.927 7.271.923-4.831 1.434-7.732 1.434-7.732-2.374 3.066-6.001-2.984-14.476-7.205Z"
        opacity={0.16}
      />
    </g>
    <path
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M291.397 379.071c-2.423 3.017-6.05-3.033-14.525-7.254-5.342-2.688-13.849-5.128-20.889-7.766-1.995-4.731-4.633-10.898-6.331-14.624-3.017-6.594-7.864-2.423-7.864-2.423a35.269 35.269 0 0 1-6.051-9.678c-3.017-6.595-7.864-6.051-14.509-7.254-6.644-1.204-20.576-13.916-20.576-13.916s-6.512-4.946-9.199-7.402c-3.133 6.166-10.634 17.014-26.858 23.791 25.868 27.022 78.347 78.363 83.854 82.221 6.05 4.22 4.237 16.322 0 28.423-4.238 12.102-19.966 29.677-19.356 49 .61 19.323 6.595 49 6.05 55.051-.544 5.391-12.612 22.29-15.234 25.917l6.15.693h32.018c-.181-16.224-.165-82.436 10.931-108.815 12.712-30.32 22.389-85.964 22.389-85.964Z"
    />
    <path
      fill="#EA580C"
      d="M291.826 376.961s-7.518-2.308-12.151 1.748c-4.633 4.055-11.541 24.862-15.613 47.433a63.08 63.08 0 0 0 4.946 38.827s9.513-24.945 12.398-37.096c2.885-12.151 10.42-50.912 10.42-50.912Z"
    />
    <mask
      id="f"
      width={30}
      height={89}
      x={262}
      y={376}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "luminance",
      }}
    >
      <path
        fill="#fff"
        d="M291.826 376.961s-7.518-2.308-12.151 1.748c-4.633 4.055-11.541 24.862-15.613 47.433a63.08 63.08 0 0 0 4.946 38.827s9.513-24.945 12.398-37.096c2.885-12.151 10.42-50.912 10.42-50.912Z"
      />
    </mask>
    <g mask="url(#f)">
      <path
        fill="#000"
        d="M277.4 380.637s5.441-1.319 7.683-.56a21.937 21.937 0 0 1 5.243 3.182l1.5-6.298a12.168 12.168 0 0 0-7.304-1.204c-3.742.759-7.122 4.88-7.122 4.88Z"
        opacity={0.16}
      />
    </g>
    <path
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M291.826 376.961s-7.518-2.308-12.151 1.748c-4.633 4.055-11.541 24.862-15.613 47.433a63.08 63.08 0 0 0 4.946 38.827s9.513-24.945 12.398-37.096c2.885-12.151 10.42-50.912 10.42-50.912ZM241.194 378.939l9.678 39.322-21.779-49.61"
    />
    <path
      fill="#EA580C"
      d="M304.95 573.85h70.532s-19.455-24.731-19.455-33.189c0-8.458 26.709-116.827 27.912-124.692 1.204-7.864-3.627-13.305-13.305-13.915-9.678-.61-46.576-8.474-48.389-14.525 0 0-13.915 49-18.746 82.271-4.155 28.539.148 87.76 1.451 104.05Z"
    />
    <mask
      id="g"
      width={84}
      height={187}
      x={301}
      y={387}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "luminance",
      }}
    >
      <path
        fill="#fff"
        d="M304.95 573.85h70.532s-19.455-24.731-19.455-33.189c0-8.458 26.709-116.827 27.912-124.692 1.204-7.864-3.627-13.305-13.305-13.915-9.678-.61-46.576-8.474-48.389-14.525 0 0-13.915 49-18.746 82.271-4.155 28.539.148 87.76 1.451 104.05Z"
      />
    </mask>
    <g mask="url(#g)">
      <path
        fill="#000"
        d="M370.634 402.054c-7.93-.494-34.128-5.869-44.333-11.112l3.709 8.573a74.365 74.365 0 0 0 21.433 7.452c12.283 2.193 23.709 1.764 31.178 12.745l.362.544c.462-2.11.775-3.594.874-4.287 1.303-7.864-3.545-13.305-13.223-13.915Z"
        opacity={0.16}
      />
    </g>
    <path
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M304.95 573.85h70.532s-19.455-24.731-19.455-33.189c0-8.458 26.709-116.827 27.912-124.692 1.204-7.864-3.627-13.305-13.305-13.915-9.678-.61-46.576-8.474-48.389-14.525 0 0-13.915 49-18.746 82.271-4.155 28.539.148 87.76 1.451 104.05Z"
    />
    <path
      fill="#EA580C"
      d="M322.245 387.529s-18.664 59.354-18.746 82.271c0 0 26.511-32.101 29.973-54.655 3.463-22.554-11.227-27.616-11.227-27.616Z"
    />
    <mask
      id="h"
      width={32}
      height={83}
      x={303}
      y={387}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "luminance",
      }}
    >
      <path
        fill="#fff"
        d="M322.245 387.529s-18.664 59.354-18.746 82.271c0 0 26.511-32.101 29.973-54.655 3.463-22.554-11.227-27.616-11.227-27.616Z"
      />
    </mask>
    <g mask="url(#h)">
      <path
        fill="#000"
        d="M319.03 395.113a17.287 17.287 0 0 1 14.492 7.024s-3.66-10.766-11.277-14.608l-3.215 7.584Z"
        opacity={0.16}
      />
    </g>
    <path
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M322.245 387.529s-18.664 59.354-18.746 82.271c0 0 26.511-32.101 29.973-54.655 3.463-22.554-11.227-27.616-11.227-27.616Z"
    />
    <path
      fill="#fff"
      d="M521.491 562.688s13.668.561 22.62 1.847a163.625 163.625 0 0 0 18.004 1.434s-4.946-9.991-10.222-12.811c-5.275-2.819-14.838-7.864-22.851-6.743-8.012 1.121-19.471 9.2-18.515 11.772.957 2.572 5.227 3.726 10.964 4.501Z"
    />
    <mask
      id="i"
      width={53}
      height={20}
      x={510}
      y={546}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "luminance",
      }}
    >
      <path
        fill="#fff"
        d="M521.491 562.688s13.668.561 22.62 1.847a163.625 163.625 0 0 0 18.004 1.434s-4.946-9.991-10.222-12.811c-5.275-2.819-14.838-7.864-22.851-6.743-8.012 1.121-19.471 9.2-18.515 11.772.957 2.572 5.227 3.726 10.964 4.501Z"
      />
    </mask>
    <g mask="url(#i)">
      <path
        fill="#EA580C"
        d="M521.491 562.688s13.668.561 22.62 1.847a163.625 163.625 0 0 0 18.004 1.434s-4.946-9.991-10.222-12.811c-5.275-2.819-14.838-7.864-22.851-6.743-8.012 1.121-19.471 9.2-18.515 11.772.957 2.572 5.227 3.726 10.964 4.501Z"
      />
      <path
        fill="#fff"
        d="M521.491 562.688s13.668.561 22.62 1.847a163.625 163.625 0 0 0 18.004 1.434s-4.946-9.991-10.222-12.811c-5.275-2.819-14.838-7.864-22.851-6.743-8.012 1.121-19.471 9.2-18.515 11.772.957 2.572 5.227 3.726 10.964 4.501Z"
        opacity={0.5}
      />
    </g>
    <path
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M521.491 562.688s13.668.561 22.621 1.847c5.97.809 11.98 1.288 18.003 1.434 0 0-4.946-9.991-10.222-12.811-5.275-2.819-14.838-7.864-22.851-6.743-8.012 1.121-19.471 9.2-18.515 11.772.957 2.572 5.227 3.726 10.964 4.501Z"
    />
    <path
      fill="#fff"
      d="M544.194 558.599s10.832-5.622 13.536-5.54c2.704.083 20.675 12.234 19.784 14.179a5.171 5.171 0 0 1-5.671 2.111c-1.995-.94-14.097-6.084-14.097-6.084l-7.913 1.863-5.639-6.529Z"
    />
    <mask
      id="j"
      width={34}
      height={17}
      x={544}
      y={553}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "luminance",
      }}
    >
      <path
        fill="#fff"
        d="M544.194 558.599s10.832-5.622 13.536-5.54c2.704.083 20.675 12.234 19.784 14.179a5.171 5.171 0 0 1-5.671 2.111c-1.995-.94-14.097-6.084-14.097-6.084l-7.913 1.863-5.639-6.529Z"
      />
    </mask>
    <g mask="url(#j)">
      <path
        fill="#EA580C"
        d="M544.194 558.599s10.832-5.622 13.536-5.54c2.704.083 20.675 12.234 19.784 14.179-.89 1.946-5.144 3.529-5.671 2.111-.528-1.418-14.097-6.084-14.097-6.084l-7.913 1.863-5.639-6.529Z"
      />
      <path
        fill="#fff"
        d="M544.194 558.599s10.832-5.622 13.536-5.54c2.704.083 20.675 12.234 19.784 14.179-.89 1.946-5.144 3.529-5.671 2.111-.528-1.418-14.097-6.084-14.097-6.084l-7.913 1.863-5.639-6.529Z"
        opacity={0.5}
      />
    </g>
    <path
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M544.194 558.599s10.832-5.622 13.536-5.54c2.704.083 20.675 12.234 19.784 14.179a5.171 5.171 0 0 1-5.671 2.111c-1.995-.94-14.097-6.084-14.097-6.084l-7.913 1.863-5.639-6.529Z"
    />
    <path
      fill="#fff"
      d="M536.462 549.35s14.442-.462 17.311.989c2.869 1.451 15.828 23.676 13.882 25.291-1.945 1.616-7.32 1.138-7.155-.659.165-1.797-11.937-13.701-11.937-13.701l-9.414-2.061-2.687-9.859Z"
    />
    <mask
      id="k"
      width={32}
      height={28}
      x={536}
      y={549}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "luminance",
      }}
    >
      <path
        fill="#fff"
        d="M536.462 549.35s14.442-.462 17.311.989c2.869 1.451 15.828 23.676 13.882 25.291-1.945 1.616-7.32 1.138-7.155-.659.165-1.797-11.937-13.701-11.937-13.701l-9.414-2.061-2.687-9.859Z"
      />
    </mask>
    <g mask="url(#k)">
      <path
        fill="#EA580C"
        d="M536.462 549.35s14.442-.462 17.311.989c2.869 1.451 15.828 23.676 13.882 25.291-1.945 1.616-7.32 1.138-7.155-.659.165-1.797-11.937-13.701-11.937-13.701l-9.414-2.061-2.687-9.859Z"
      />
      <path
        fill="#fff"
        d="M536.462 549.35s14.442-.462 17.311.989c2.869 1.451 15.828 23.676 13.882 25.291-1.945 1.616-7.32 1.138-7.155-.659.165-1.797-11.937-13.701-11.937-13.701l-9.414-2.061-2.687-9.859Z"
        opacity={0.5}
      />
    </g>
    <path
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M536.462 549.35s14.442-.462 17.311.989c2.869 1.451 15.828 23.676 13.882 25.291-1.945 1.616-7.32 1.138-7.155-.659.165-1.797-11.937-13.701-11.937-13.701l-9.414-2.061-2.687-9.859Z"
    />
    <path
      fill="#fff"
      d="M527.905 546.366s14.624-.478 17.526 1.005c2.901 1.484 16.025 23.956 14.046 25.605-1.978 1.649-7.386 1.137-7.221-.676.165-1.814-12.085-13.866-12.085-13.866l-9.529-2.094-2.737-9.974Z"
    />
    <mask
      id="l"
      width={33}
      height={28}
      x={527}
      y={546}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "luminance",
      }}
    >
      <path
        fill="#fff"
        d="M527.905 546.366s14.624-.478 17.526 1.005c2.901 1.484 16.025 23.956 14.046 25.605-1.978 1.649-7.386 1.137-7.221-.676.165-1.814-12.085-13.866-12.085-13.866l-9.529-2.094-2.737-9.974Z"
      />
    </mask>
    <g mask="url(#l)">
      <path
        fill="#EA580C"
        d="M527.905 546.366s14.624-.478 17.526 1.005c2.901 1.484 16.025 23.956 14.046 25.605-1.978 1.649-7.386 1.137-7.221-.676.165-1.814-12.085-13.866-12.085-13.866l-9.529-2.094-2.737-9.974Z"
      />
      <path
        fill="#fff"
        d="M527.905 546.366s14.624-.478 17.526 1.005c2.901 1.484 16.025 23.956 14.046 25.605-1.978 1.649-7.386 1.137-7.221-.676.165-1.814-12.085-13.866-12.085-13.866l-9.529-2.094-2.737-9.974Z"
        opacity={0.5}
      />
    </g>
    <path
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M527.905 546.366s14.624-.478 17.526 1.005c2.901 1.484 16.025 23.956 14.046 25.605-1.978 1.649-7.386 1.137-7.221-.676.165-1.814-12.085-13.866-12.085-13.866l-9.529-2.094-2.737-9.974Z"
    />
    <path
      fill="#EA580C"
      d="M361.632 462.578c10.585 16.306 31.837 57.623 38.036 62.272 9.678 7.254 74.373 24.863 80.606 29.677 6.232 4.814 5.803 9.645 11.705 11.409 5.903 1.764 28.028 6.826 36.47 7.617 8.441.791 4.666-4.435 4.666-4.435l-14.394-9.892 12.547-3.1s12.58 15.135 14.937 15.96c2.358.824 6.513 0 6.249-1.863-.462-2.985-13.882-27.402-18.647-28.441-4.765-1.038-33.683 2.968-33.683 2.968s-60.656-40.904-61.744-42.355c0 0-3.627-10.288-6.595-14.525-2.968-4.238-4.847-3.018-4.847-3.018s1.22-5.457-.594-7.27l-9.678-9.678-.346.461c-1.649-3.297-3.297-7.056-5.111-11.343-5.061-11.92-22.983-45.372-26-50.203-2.259-3.611-21.186-6.199-30.781-7.287"
    />
    <mask
      id="m"
      width={199}
      height={175}
      x={354}
      y={399}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "luminance",
      }}
    >
      <path
        fill="#fff"
        d="M361.632 462.578c10.585 16.306 31.837 57.623 38.036 62.272 9.678 7.254 74.373 24.863 80.606 29.677 6.232 4.814 5.803 9.645 11.705 11.409 5.903 1.764 28.028 6.826 36.47 7.617 8.441.791 4.666-4.435 4.666-4.435l-14.394-9.892 12.547-3.1s12.58 15.135 14.937 15.96c2.358.824 6.513 0 6.249-1.863-.462-2.985-13.882-27.402-18.647-28.441-4.765-1.038-33.683 2.968-33.683 2.968s-60.656-40.904-61.744-42.355c0 0-3.627-10.288-6.595-14.525-2.968-4.238-4.847-3.018-4.847-3.018s1.22-5.457-.594-7.27l-9.678-9.678-.346.461c-1.649-3.297-3.297-7.056-5.111-11.343-5.061-11.92-22.983-45.372-26-50.203-2.259-3.611-21.186-6.199-30.781-7.287"
      />
    </mask>
    <g mask="url(#m)">
      <path
        fill="#000"
        d="M403.773 463.617c7.914 7.024 5.276 7.024 3.512 13.19-1.764 6.166 1.319-2.193 8.788-1.748 7.468.445 5.276 10.09 4.385 11.854-.89 1.764 9.233 3.957 7.469 7.898-1.764 3.94-11.854 9.661-17.559 15.382-5.704 5.721 14.921-9.233 21.945-9.661 2.143-.149 3.907.131 5.391.099a69.286 69.286 0 0 0-5.968-12.663c-3.034-4.237-4.848-3.017-4.848-3.017s1.22-5.457-.593-7.27l-9.678-9.678-.346.461c-1.649-3.297-3.298-7.056-5.111-11.343-5.062-11.92-22.983-45.372-26-50.203-2.259-3.611-21.186-6.199-30.782-7.287l.874 7.633.214.165s11.854 2.193 15.811 2.638c3.957.445 8.788 3.94 8.343 6.595-.445 2.654-11.854 14.492-8.343 15.382 3.512.89 7.469-8.787 11.426-7.468 3.957 1.319 13.107 32.018 21.07 39.041Z"
        opacity={0.16}
      />
    </g>
    <path
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M361.632 462.578c10.585 16.306 31.837 57.623 38.036 62.272 9.678 7.254 74.373 24.863 80.606 29.677 6.232 4.814 5.803 9.645 11.705 11.409 5.903 1.764 28.028 6.826 36.47 7.617 8.441.791 4.666-4.435 4.666-4.435l-14.394-9.892 12.547-3.1s12.58 15.135 14.937 15.96c2.358.824 6.513 0 6.249-1.863-.462-2.985-13.882-27.402-18.647-28.441-4.765-1.038-33.683 2.968-33.683 2.968s-60.656-40.904-61.744-42.355c0 0-3.627-10.288-6.595-14.525-2.968-4.238-4.847-3.018-4.847-3.018s1.22-5.457-.594-7.27l-9.678-9.678-.346.461c-1.649-3.297-3.297-7.056-5.111-11.343-5.061-11.92-22.983-45.372-26-50.203-2.259-3.611-21.186-6.199-30.781-7.287"
    />
    <path
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M361.797 440.205a47.025 47.025 0 0 0-1.121 4.485M377.823 412.919a88.265 88.265 0 0 0-12.992 19.537M402.042 506.533c4.452-6.595 11.541-14.954 19.356-17.345M397.113 514.645s.791-1.55 2.209-3.891M397.113 504.225s8.095-20.246 16.19-25.456c8.095-5.21 3.462 5.21 3.462 5.21"
    />
    <path
      fill="#fff"
      d="M480.274 554.543c6.248 4.831 5.803 9.645 11.705 11.409 5.903 1.765 28.028 6.826 36.47 7.618 8.441.791 4.666-4.435 4.666-4.435l-14.394-9.893 12.547-3.099s12.58 15.135 14.937 15.959c2.358.825 6.843 1.121 6.249-1.863-1.154-5.77-13.882-27.401-18.647-28.44-4.765-1.039-33.683 2.968-33.683 2.968s-55.248-37.921-61.299-42.026c-23.461 2.259-34.623 14.542-39.322 21.911l.165.132c9.678 7.32 74.373 24.929 80.606 29.759Z"
    />
    <mask
      id="n"
      width={154}
      height={72}
      x={399}
      y={502}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "luminance",
      }}
    >
      <path
        fill="#fff"
        d="M480.274 554.543c6.248 4.831 5.803 9.645 11.705 11.409 5.903 1.765 28.028 6.826 36.47 7.618 8.441.791 4.666-4.435 4.666-4.435l-14.394-9.893 12.547-3.099s12.58 15.135 14.937 15.959c2.358.825 6.843 1.121 6.249-1.863-1.154-5.77-13.882-27.401-18.647-28.44-4.765-1.039-33.683 2.968-33.683 2.968s-55.248-37.921-61.299-42.026c-23.461 2.259-34.623 14.542-39.322 21.911l.165.132c9.678 7.32 74.373 24.929 80.606 29.759Z"
      />
    </mask>
    <g mask="url(#n)">
      <path
        fill="#EA580C"
        d="M552.437 570.305c-3-7.337-13.882-27.402-18.646-28.44-4.765-1.039-33.684 2.967-33.684 2.967s-55.248-37.92-61.299-42.025a61.407 61.407 0 0 0-17.921 4.336c8.722 4.946 66.855 37.92 74.192 39.388 7.782 1.648 33.749-2.622 38.316.445 2.902 1.945 11.541 15.646 17.377 25.373 1.665-.247 2.276-.56 1.665-2.044Z"
      />
      <path
        fill="#fff"
        d="M552.437 570.305c-4.682-10.502-13.882-27.402-18.646-28.44-4.765-1.039-33.684 2.967-33.684 2.967s-55.248-37.92-61.299-42.025a61.407 61.407 0 0 0-17.921 4.336c8.722 4.946 66.855 37.92 74.192 39.388 7.782 1.648 33.749-2.622 38.316.445 2.902 1.945 11.541 15.646 17.377 25.373 1.665-.247 2.325-.577 1.665-2.044Z"
        opacity={0.5}
      />
    </g>
    <path
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M480.274 554.543c6.248 4.831 5.803 9.645 11.705 11.409 5.903 1.765 28.028 6.826 36.47 7.618 8.441.791 4.666-4.435 4.666-4.435l-14.394-9.893 12.547-3.099s12.58 15.135 14.937 15.959c2.358.825 6.843 1.121 6.249-1.863-1.154-5.77-13.882-27.401-18.647-28.44-4.765-1.039-33.683 2.968-33.683 2.968s-55.248-37.921-61.299-42.026c-23.461 2.259-34.623 14.542-39.322 21.911l.165.132c9.678 7.32 74.373 24.929 80.606 29.759Z"
    />
    <path
      fill="#fff"
      d="m334.561 266.646-49.66 20.724a73.197 73.197 0 0 1-6.38 25.242c-5.869 12.414-2.44 35.909 3.198 48.587 5.639 12.679 30.485 7.716 39.57 6.133a97.952 97.952 0 0 0 18.02-5.259 16.745 16.745 0 0 0 16.091-2.242s-26.577-74.604-20.839-93.185Z"
    />
    <mask
      id="o"
      width={81}
      height={104}
      x={275}
      y={266}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "luminance",
      }}
    >
      <path
        fill="#fff"
        d="m334.561 266.646-49.66 20.724a73.197 73.197 0 0 1-6.38 25.242c-5.869 12.414-2.44 35.909 3.198 48.587 5.639 12.679 30.485 7.716 39.57 6.133a97.952 97.952 0 0 0 18.02-5.259 16.745 16.745 0 0 0 16.091-2.242s-26.577-74.604-20.839-93.185Z"
      />
    </mask>
    <g mask="url(#o)">
      <path
        fill="#EA580C"
        d="m334.561 266.646-49.66 20.724a73.197 73.197 0 0 1-6.38 25.242c-5.869 12.414-2.44 35.909 3.198 48.587a11.54 11.54 0 0 0 4.37 4.946v-.956s-9.217-22.835-7.469-36.008c1.748-13.173 9.233-19.784 10.106-28.11.874-8.326.429-12.283 17.131-18.433 16.701-6.15 23.708-11.854 25.456-5.721 1.747 6.133 8.787 46.56 13.618 56.221 4.831 9.662 4.386 19.785-3.067 24.154a104.76 104.76 0 0 1-24.021 10.584l3.511-.61a97.939 97.939 0 0 0 18.021-5.259 16.745 16.745 0 0 0 16.091-2.242s-26.643-74.538-20.905-93.119Z"
      />
      <path
        fill="#fff"
        d="m334.561 266.646-49.66 20.724a73.197 73.197 0 0 1-6.38 25.242c-5.869 12.414-2.44 35.909 3.198 48.587a11.54 11.54 0 0 0 4.37 4.946v-.956s-9.217-22.835-7.469-36.008c1.748-13.173 9.233-19.784 10.106-28.11.874-8.326.429-12.283 17.131-18.433 16.701-6.15 23.708-11.854 25.456-5.721 1.747 6.133 8.787 46.56 13.618 56.221 4.831 9.662 4.386 19.785-3.067 24.154a104.76 104.76 0 0 1-24.021 10.584l3.511-.61a97.939 97.939 0 0 0 18.021-5.259 16.745 16.745 0 0 0 16.091-2.242s-26.643-74.538-20.905-93.119Z"
        opacity={0.5}
      />
    </g>
    <path
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m334.561 266.646-49.66 20.724a73.197 73.197 0 0 1-6.38 25.242c-5.869 12.414-2.44 35.909 3.198 48.587 5.639 12.679 30.485 7.716 39.57 6.133a97.952 97.952 0 0 0 18.02-5.259 16.745 16.745 0 0 0 16.091-2.242s-26.577-74.604-20.839-93.185Z"
    />
    <path
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M309.467 299.142a25.792 25.792 0 0 1-1.071 8.639c-1.319 3.297-13.767 16.256-13.388 17.658.379 1.401 1.5 5.902 3.71 6.331M323.267 310.732c1.731-3.462 7.419-.082 7.337 7.716M295.074 300.543s4.847-2.127 9.183 5.721"
    />
    <path
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M316.375 322.158a24.007 24.007 0 0 1 15.053 6.314M289.221 311.853a31.957 31.957 0 0 1 8.409 2.325"
    />
    <path
      fill="#263238"
      d="M308.923 291.822a9.342 9.342 0 0 0-8.342-.198c-4.435 2.127-7.156 4.468-6.859 1.747.297-2.72 5.507-5.721 7.073-6.116 1.566-.396 8.573-1.484 8.128 4.567ZM321.354 285.672a37.707 37.707 0 0 1 10.717 13.948c3.297 8.243 5.902-.759 3.297-6.15s-10.139-11.129-14.014-7.798Z"
    />
    <path
      fill="#EA580C"
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M356.126 373.927c0 3.842-2.177 6.958-4.847 6.958-2.671 0-4.831-3.116-4.831-6.958 0-3.841 2.16-13.618 4.831-13.618 2.67 0 4.847 9.777 4.847 13.618Z"
    />
    <path
      fill="#263238"
      d="M323.696 309.232c-.19.504-.339 1.022-.446 1.55-.478 2.44-.956 7.534 0 7.749.957.214 3.298-4.551 3.71-6.991.093-.479.148-.964.165-1.451a29.938 29.938 0 0 0-3.429-.857ZM295.569 300.065a9.552 9.552 0 0 0-.347 1.319c-.494 2.44-.478 7.798.561 7.996 1.039.198 2.737-4.814 3.215-7.254.119-.592.185-1.193.198-1.797a9.346 9.346 0 0 0-3.627-.264Z"
    />
    <path
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.75}
      d="m323.267 310.815 1.649-3.067a11.915 11.915 0 0 1 6.726 3.891M295.569 300.065l1.648-1.929s.709-.346 4.6 1.418"
    />
    <path
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M289.32 344.778s2.77-5.094 6.479-5.094c3.71 0 6.48 8.325 6.48 8.325"
    />
    <path
      fill="#263238"
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M381.532 573.85H212.144l-5.523-93.119a6.328 6.328 0 0 1 6.182-7.387h168.004a6.33 6.33 0 0 1 6.112 4.659 6.33 6.33 0 0 1 .137 2.728l-5.524 93.119Z"
    />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M220.486 475.57h159.101a6.162 6.162 0 0 1 4.74 2.147 6.173 6.173 0 0 1 1.41 5.009M207.857 481.258a6.216 6.216 0 0 1 6.233-5.688"
    />
    <path
      fill="#fff"
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M382.241 564.782H211.435v9.068h170.806v-9.068ZM296.228 531.214c6.684 0 12.102-3.248 12.102-7.254 0-4.007-5.418-7.255-12.102-7.255-6.683 0-12.101 3.248-12.101 7.255 0 4.006 5.418 7.254 12.101 7.254Z"
    />
    <path fill="#263238" d="M639.869 572.778H3.698v15.448h636.171v-15.448Z" />
    <path
      fill="#EA580C"
      d="M474.915 0h-306.05c-10.316 0-18.679 8.363-18.679 18.68v175.604c0 10.316 8.363 18.68 18.679 18.68h306.05c10.317 0 18.68-8.364 18.68-18.68V18.68c0-10.317-8.363-18.68-18.68-18.68Z"
    />
    <path
      fill="#263238"
      d="M329.966 122.384c27.762-4.462 46.65-30.584 42.189-58.346-4.462-27.761-30.584-46.65-58.346-42.188-27.762 4.461-46.65 30.584-42.188 58.345 4.461 27.762 30.583 46.651 58.345 42.189Z"
    />
    <path
      fill="#fff"
      d="m321.503 81.529-16.965 21.779a6.485 6.485 0 0 1-5.375 3.001 5.588 5.588 0 0 1-3.957-1.567 5.079 5.079 0 0 1-1.25-1.774 5.083 5.083 0 0 1-.399-2.133 7.646 7.646 0 0 1 1.649-4.5l19.339-23.924-18.135-23.939a6.592 6.592 0 0 1-1.319-3.89 6.054 6.054 0 0 1 1.929-4.469 6.147 6.147 0 0 1 4.451-1.896 6.38 6.38 0 0 1 5.309 3L323.168 62.8l16.487-21.219a7.015 7.015 0 0 1 5.655-3.412 5.191 5.191 0 0 1 3.809 1.648 5.243 5.243 0 0 1 1.648 3.809 5.771 5.771 0 0 1-1.252 3.512l-19.406 24.83 18.746 24.73a6.38 6.38 0 0 1 1.401 3.891 5.64 5.64 0 0 1-.506 2.375 5.637 5.637 0 0 1-1.456 1.944 6.489 6.489 0 0 1-4.501 1.814 6.395 6.395 0 0 1-5.341-3.001l-16.949-22.191ZM418.892 176.082H224.823a14.838 14.838 0 1 1 0-29.677h194.069a14.838 14.838 0 0 1 0 29.677Z"
    />
    <path
      fill="#000"
      d="M251.416 166.025a.955.955 0 0 1-.692-.297.995.995 0 0 1-.297-.742c0-.232.063-.46.181-.659l1.484-2.308h-3.033a.998.998 0 0 1-.759-.297 1.09 1.09 0 0 1 0-1.418.998.998 0 0 1 .759-.297l2.984.083-1.319-2.144a1.496 1.496 0 0 1-.214-.725 1.007 1.007 0 0 1 1.005-1.039.938.938 0 0 1 .874.561l1.451 2.588 1.385-2.473a1.148 1.148 0 0 1 .989-.676.957.957 0 0 1 .693.297.93.93 0 0 1 .296.709 1.233 1.233 0 0 1-.198.659l-1.45 2.325 3.017-.082a.97.97 0 0 1 .758.296 1.087 1.087 0 0 1 0 1.418.959.959 0 0 1-.758.297h-3.05l1.352 2.11c.152.255.237.545.247.841a.99.99 0 0 1-.28.726.952.952 0 0 1-.676.296 1.062 1.062 0 0 1-.572-.182 1.062 1.062 0 0 1-.385-.461l-1.368-2.423-1.369 2.423a1.106 1.106 0 0 1-1.055.594ZM266.551 166.025a.955.955 0 0 1-.692-.297.995.995 0 0 1-.297-.742c0-.232.063-.46.182-.659l1.483-2.308h-3.033a.993.993 0 0 1-.759-.297 1.09 1.09 0 0 1 0-1.418.993.993 0 0 1 .759-.297l2.984.083-1.401-2.226a1.501 1.501 0 0 1-.215-.726 1 1 0 0 1 .297-.741.98.98 0 0 1 .709-.297.94.94 0 0 1 .874.56l1.451 2.589 1.385-2.473a1.151 1.151 0 0 1 .989-.676.955.955 0 0 1 .692.297.926.926 0 0 1 .297.708 1.236 1.236 0 0 1-.198.66l-1.451 2.325 3.017-.083a.98.98 0 0 1 .759.297 1.09 1.09 0 0 1 0 1.418.978.978 0 0 1-.759.297h-3.05l1.352 2.11c.153.255.238.544.248.841a.983.983 0 0 1-.281.725.936.936 0 0 1-.676.297 1.054 1.054 0 0 1-.956-.643l-1.368-2.424-1.369 2.424a1.102 1.102 0 0 1-.973.676ZM281.687 166.025a.956.956 0 0 1-.693-.297 1.01 1.01 0 0 1-.297-.742c0-.232.063-.46.182-.659l1.484-2.308h-3.034a.996.996 0 0 1-.758-.297 1.085 1.085 0 0 1 0-1.418.989.989 0 0 1 .758-.297l2.984.083-1.401-2.226a1.501 1.501 0 0 1-.215-.726 1 1 0 0 1 .297-.741.97.97 0 0 1 .325-.22.972.972 0 0 1 .384-.077.94.94 0 0 1 .874.56l1.451 2.589 1.385-2.473a1.151 1.151 0 0 1 .989-.676.96.96 0 0 1 .692.297.942.942 0 0 1 .297.708 1.236 1.236 0 0 1-.198.66l-1.451 2.325 3.018-.083a.978.978 0 0 1 .758.297 1.09 1.09 0 0 1 0 1.418.978.978 0 0 1-.758.297h-3.051l1.352 2.11c.153.255.238.544.248.841.004.133-.018.267-.066.391a.968.968 0 0 1-.215.334.925.925 0 0 1-.676.297 1.057 1.057 0 0 1-.956-.643l-1.368-2.424-1.369 2.424a1.102 1.102 0 0 1-.972.676ZM296.888 166.025a.956.956 0 0 1-.693-.297 1.01 1.01 0 0 1-.297-.742c0-.232.063-.46.182-.659l1.484-2.308h-3.034a.996.996 0 0 1-.758-.297 1.085 1.085 0 0 1 0-1.418.989.989 0 0 1 .758-.297l2.984.083-1.401-2.226a1.512 1.512 0 0 1-.215-.726 1.018 1.018 0 0 1 .622-.961.972.972 0 0 1 .384-.077.945.945 0 0 1 .522.148c.155.1.277.243.352.412l1.451 2.589 1.385-2.473a1.151 1.151 0 0 1 .989-.676.96.96 0 0 1 .692.297.942.942 0 0 1 .297.708 1.236 1.236 0 0 1-.198.66l-1.45 2.325 3.017-.083a.978.978 0 0 1 .758.297 1.085 1.085 0 0 1 0 1.418.97.97 0 0 1-.758.297h-3.05l1.351 2.11c.153.255.238.544.248.841.004.133-.018.267-.066.391a.968.968 0 0 1-.215.334.925.925 0 0 1-.675.297 1.068 1.068 0 0 1-.957-.643l-1.368-2.424-1.369 2.424a1.104 1.104 0 0 1-.972.676ZM311.957 166.025a.956.956 0 0 1-.693-.297 1.01 1.01 0 0 1-.296-.742 1.45 1.45 0 0 1 .181-.659l1.484-2.308h-3.034a.996.996 0 0 1-.758-.297 1.085 1.085 0 0 1 0-1.418.989.989 0 0 1 .758-.297l2.984.083-1.401-2.226a1.5 1.5 0 0 1-.214-.726 1 1 0 0 1 .296-.741.97.97 0 0 1 .325-.22.976.976 0 0 1 .384-.077.94.94 0 0 1 .874.56l1.451 2.589 1.385-2.473a1.159 1.159 0 0 1 .989-.676.924.924 0 0 1 .693.297.94.94 0 0 1 .296.708c-.002.235-.07.463-.197.66l-1.451 2.325 3.017-.083a.981.981 0 0 1 .758.297 1.085 1.085 0 0 1 0 1.418.966.966 0 0 1-.758.297h-3.05l1.352 2.11c.152.255.237.544.247.841a.985.985 0 0 1-.28.725.94.94 0 0 1-.676.297 1.07 1.07 0 0 1-.957-.643l-1.368-2.424-1.368 2.424a1.109 1.109 0 0 1-.973.676ZM327.092 166.025a.96.96 0 0 1-.692-.297.997.997 0 0 1-.297-.742c.008-.231.07-.457.181-.659l1.484-2.308h-3.017a1.02 1.02 0 0 1-.775-.297 1.09 1.09 0 0 1 0-1.418 1.007 1.007 0 0 1 .775-.297l2.968.083-1.402-2.226a1.5 1.5 0 0 1-.214-.726 1 1 0 0 1 .297-.741.98.98 0 0 1 .709-.297.94.94 0 0 1 .873.56l1.451 2.589 1.385-2.473a1.159 1.159 0 0 1 .989-.676.924.924 0 0 1 .693.297.94.94 0 0 1 .297.708 1.245 1.245 0 0 1-.198.66l-1.451 2.325 3.017-.083a.981.981 0 0 1 .758.297 1.085 1.085 0 0 1 0 1.418.966.966 0 0 1-.758.297h-3.05l1.352 2.11c.152.255.238.544.247.841a.985.985 0 0 1-.28.725.94.94 0 0 1-.676.297 1.07 1.07 0 0 1-.956-.643l-1.369-2.424-1.368 2.424a1.102 1.102 0 0 1-.973.676ZM342.227 166.025a.963.963 0 0 1-.692-.297 1.012 1.012 0 0 1-.297-.742c0-.232.062-.46.181-.659l1.484-2.308h-3.033a.998.998 0 0 1-.759-.297 1.09 1.09 0 0 1 0-1.418.998.998 0 0 1 .759-.297l2.984.083-1.451-2.144a1.508 1.508 0 0 1-.215-.725 1.02 1.02 0 0 1 1.006-1.039.946.946 0 0 1 .874.561l1.451 2.588 1.385-2.473a1.148 1.148 0 0 1 .989-.676.925.925 0 0 1 .692.297.93.93 0 0 1 .297.709 1.233 1.233 0 0 1-.198.659l-1.45 2.325 3.017-.082a.97.97 0 0 1 .758.296 1.087 1.087 0 0 1 0 1.418.959.959 0 0 1-.758.297h-3.05l1.352 2.11c.152.255.237.545.247.841a.99.99 0 0 1-.28.726.952.952 0 0 1-.676.296 1.06 1.06 0 0 1-.572-.182 1.062 1.062 0 0 1-.385-.461l-1.368-2.423-1.369 2.423a1.095 1.095 0 0 1-.923.594ZM357.362 166.025a.955.955 0 0 1-.692-.297.995.995 0 0 1-.297-.742c.008-.231.07-.457.181-.659l1.484-2.308h-3.017a.954.954 0 0 1-.413-.062.95.95 0 0 1-.345-.235 1.037 1.037 0 0 1 0-1.418.95.95 0 0 1 .345-.235.954.954 0 0 1 .413-.062l2.968.083-1.402-2.226a1.5 1.5 0 0 1-.214-.725 1.002 1.002 0 0 1 .283-.733c.094-.097.206-.174.33-.227.124-.052.258-.079.393-.079a.942.942 0 0 1 .874.56l1.451 2.589 1.384-2.473a1.157 1.157 0 0 1 .99-.676c.13-.004.259.02.379.071a.91.91 0 0 1 .313.226.926.926 0 0 1 .297.709 1.235 1.235 0 0 1-.198.659l-1.451 2.325 3.017-.083a.98.98 0 0 1 .759.297 1.09 1.09 0 0 1 0 1.418.978.978 0 0 1-.759.297h-3.05l1.352 2.11c.153.255.238.544.247.841a.972.972 0 0 1-.266.709.976.976 0 0 1-.69.313 1.073 1.073 0 0 1-.956-.643l-1.368-2.424-1.369 2.424a1.102 1.102 0 0 1-.973.676ZM372.497 166.025a.955.955 0 0 1-.692-.297 1.01 1.01 0 0 1-.297-.742c.008-.231.07-.457.182-.659l1.483-2.308h-3.033a.945.945 0 0 1-.742-.297 1.037 1.037 0 0 1 0-1.418.935.935 0 0 1 .742-.297l2.984.083-1.401-2.226a1.5 1.5 0 0 1-.215-.725 1.02 1.02 0 0 1 .283-.733c.094-.097.206-.174.33-.227.125-.052.258-.079.393-.079a.94.94 0 0 1 .874.56l1.451 2.589 1.385-2.473a1.151 1.151 0 0 1 .989-.676.892.892 0 0 1 .692.297.926.926 0 0 1 .297.709 1.235 1.235 0 0 1-.198.659l-1.451 2.325 3.017-.083a.98.98 0 0 1 .759.297 1.09 1.09 0 0 1 0 1.418.978.978 0 0 1-.759.297h-3.05l1.352 2.11c.153.255.238.544.248.841a.991.991 0 0 1-.957 1.022 1.073 1.073 0 0 1-.956-.643l-1.368-2.424-1.369 2.424a1.102 1.102 0 0 1-.973.676ZM387.567 166.025a.956.956 0 0 1-.693-.297 1.01 1.01 0 0 1-.297-.742c.008-.231.07-.457.182-.659l1.484-2.308h-3.034a.945.945 0 0 1-.742-.297 1.036 1.036 0 0 1 0-1.418.935.935 0 0 1 .742-.297l2.984.083-1.401-2.226a1.511 1.511 0 0 1-.215-.725 1.02 1.02 0 0 1 .622-.962.972.972 0 0 1 .384-.077.94.94 0 0 1 .874.56l1.451 2.589 1.385-2.473a1.151 1.151 0 0 1 .989-.676.894.894 0 0 1 .692.297.942.942 0 0 1 .297.709 1.235 1.235 0 0 1-.198.659l-1.45 2.325 3.017-.083a.978.978 0 0 1 .758.297 1.085 1.085 0 0 1 0 1.418.97.97 0 0 1-.758.297h-3.05l1.351 2.11c.153.255.238.544.248.841a.985.985 0 0 1-.281.725.925.925 0 0 1-.675.297 1.068 1.068 0 0 1-.957-.643l-1.368-2.424-1.369 2.424a1.104 1.104 0 0 1-.972.676Z"
    />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={3}
      d="M439.435 202.495h20.164M159.765 54.028v133.925a14.624 14.624 0 0 0 14.624 14.624h245.905M159.765 18.515v20.081"
    />
  </svg>
);
export default ForgotPasswordGraphic;
